import { render, staticRenderFns } from "./PublicOnboarding.vue?vue&type=template&id=24b13f47&scoped=true"
import script from "./PublicOnboarding.vue?vue&type=script&lang=js"
export * from "./PublicOnboarding.vue?vue&type=script&lang=js"
import style0 from "./PublicOnboarding.vue?vue&type=style&index=0&id=24b13f47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b13f47",
  null
  
)

export default component.exports